import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Book } from '~/api/book/bookApiTypes';
import Modal from '~/atomic/molecula/Modal';
import { forgot } from '~/feature/authorization/auth.data';
import { authModalActions, openModal } from '~/feature/authorization/authorizationModal.slice';
import { QuickLoginForm } from '~/feature/authorization/quickAuth/QuickLoginForm';
import { subscribeBookAndOpenModal } from '~/feature/book/SubscribeBookModal/subscribeBookModal.data';
import { subscribeBookModalSelector } from '~/feature/book/SubscribeBookModal/subscribeBookModal.selector';
import { subscribeBookModalActions } from '~/feature/book/SubscribeBookModal/subscribeBookModal.slice';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { GraphqlBook } from '~/graphql/books/factory/book/BookFactoryTypes';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

interface Props {
  book?: Partial<GraphqlBook> | Book;
}

export const LoginModalWithSubscribeBook = ({ book }: Props) => {
  const dispatch = useAppDispatch();
  const { isOpenLoginModalWithSubscribeBook } = useAppSelector(subscribeBookModalSelector);
  const { quickAuthEmail } = useAppSelector(choosePaySelector);

  useEffect(() => {
    if (isOpenLoginModalWithSubscribeBook) {
      ym('reachGoal', 'open-login-modal');
    }
  }, [isOpenLoginModalWithSubscribeBook]);

  const closeModal = () => {
    dispatch(subscribeBookModalActions.setIsOpenLoginModalWithSubscribeBook(false));
  };

  const afterLoginHandler = async () => {
    closeModal();
    dispatch(subscribeBookAndOpenModal({ book }));
  };

  const onRecoveryClick = async () => {
    await dispatch(forgot({ email: quickAuthEmail }));
    dispatch(authModalActions.setSuccessRecovery(true));
    dispatch(openModal('recovery'));
    closeModal();
  };

  const onBackClick = () => {
    closeModal();
    dispatch(subscribeBookModalActions.setIsOpenAuthModalWithSubscribeBook(true));
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenLoginModalWithSubscribeBook}
    >
      <QuickLoginForm
        onBackClick={onBackClick}
        email={quickAuthEmail}
        afterLogin={afterLoginHandler}
        onRecoveryClick={onRecoveryClick}
        nextButtonText="Войти"
      />
    </SCAuthModal>
  );
};

export const SCAuthModal = styled(Modal)`
  max-width: 458px;

  .ant-modal-body {
    padding-top: 23px;
    padding-bottom: 23px;
  }

  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;
